// Configuration SEO pour toutes les pages

export const seoConfig = {
  home: {
    title: "Charles Ludig - Compositeur & Technicien Son | Musique de Film et Série TV",
    description: "Compositeur de musiques de films (Max et Léon, Les Vedettes, Bonne Conduite) et séries TV (Palmashow). Plus de 15 ans d'expérience en composition musicale et post-production audio.",
    keywords: "compositeur, musique de film, technicien son, post-production audio, Palmashow, Max et Léon, composition musicale",
    url: "https://www.charlesludig.com"
  },
  cinema: {
    title: "Cinéma - Musiques de Films | Charles Ludig",
    description: "Découvrez mes compositions pour le cinéma : Max et Léon, Les Vedettes, Bonne Conduite. Musiques originales pour longs et courts-métrages.",
    keywords: "musique de film, bande originale, compositeur cinéma, Max et Léon, Les Vedettes, Bonne Conduite",
    url: "https://www.charlesludig.com/cinema"
  },
  tvweb: {
    title: "TV & Web - Séries et Contenus Digitaux | Charles Ludig",
    description: "Compositions pour séries TV et contenus web, dont le Palmashow (TF1/Canal+). Plus de 200 épisodes produits.",
    keywords: "musique série TV, Palmashow, composition web, musique digitale, TF1, Canal+",
    url: "https://www.charlesludig.com/tvweb"
  },
  musique: {
    title: "Musique - Albums et Compositions | Charles Ludig",
    description: "Mes albums et compositions musicales : Une Nuit Infinie, bandes originales et créations personnelles. Disponibles sur Spotify.",
    keywords: "compositeur, albums, Spotify, Une Nuit Infinie, musique originale, création musicale",
    url: "https://www.charlesludig.com/musique"
  },
  studio: {
    title: "Studio - Enregistrement et Post-Production | Charles Ludig",
    description: "Studio d'enregistrement professionnel et services de post-production audio. Mixage, mastering et design sonore.",
    keywords: "studio enregistrement, post-production audio, mixage, mastering, design sonore",
    url: "https://www.charlesludig.com/studio"
  },
  tournage: {
    title: "Tournage - Prise de Son et Captation | Charles Ludig",
    description: "Services de prise de son sur tournage. Expérience sur de nombreux films et séries TV. Équipement professionnel.",
    keywords: "prise de son, tournage, technicien son, captation audio, son direct",
    url: "https://www.charlesludig.com/tournage"
  },
  bio: {
    title: "Biographie - À propos de Charles Ludig",
    description: "Parcours et expérience de Charles Ludig, compositeur et technicien son. 15 ans d'expérience dans l'audiovisuel.",
    keywords: "Charles Ludig, biographie, parcours, compositeur professionnel, technicien son",
    url: "https://www.charlesludig.com/bio"
  },
  photos: {
    title: "Photos - Galerie et Tournages | Charles Ludig",
    description: "Galerie photos des tournages et projets. Découvrez les coulisses de mes compositions et prises de son.",
    keywords: "photos tournage, galerie, coulisses, making-of, Charles Ludig",
    url: "https://www.charlesludig.com/photos"
  },
  contact: {
    title: "Contact - Charles Ludig Compositeur",
    description: "Contactez-moi pour vos projets de composition musicale, post-production audio ou prise de son. Disponible pour collaborations.",
    keywords: "contact compositeur, devis musique film, collaboration audio, Charles Ludig contact",
    url: "https://www.charlesludig.com/contact"
  }
};
